import React from 'react';

interface RulesTriggerIconProps {
  onClick: () => void;
  hasSeenRules: boolean;
}

export function RulesTriggerIcon({ onClick, hasSeenRules }: RulesTriggerIconProps) {
  return (
    <div className="relative inline-block group">
      {/* Tooltip on the LEFT side */}
      <div className="absolute right-full mr-4 top-1/2 -translate-y-1/2 hidden md:flex flex-col items-end bg-card doodle-border-soft p-2.5 shadow-doodle-sm opacity-0 translate-x-4 group-hover:opacity-100 group-hover:translate-x-0 transition-all pointer-events-none whitespace-nowrap min-w-max border-2 border-pink-100 z-50">
        <span className="text-[10px] font-black text-pink-600 uppercase tracking-widest handwritten leading-none mb-1">Rregullat e lojës</span>
        <span className="text-[9px] font-bold text-slate-400 handwritten leading-none">Mëso rregullat e lojës</span>
      </div>

      {/* The Urge Animation: Notification Dot that pings */}
      {!hasSeenRules && (
        <span className="absolute -top-2 -right-2 flex h-4 w-4 z-10">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-rose-400 opacity-75"></span>
          <span className="relative inline-flex rounded-full h-4 w-4 bg-rose-500 border-2 border-card"></span>
        </span>
      )}

      {/* The main icon button */}
      <div 
        onClick={onClick}
        className={`p-2 md:p-3 bg-pink-400 doodle-border-soft cursor-pointer transition-transform hover:scale-110 active:scale-95 ${
          !hasSeenRules ? 'animate-wiggle-strong' : ''
        }`} 
        style={{ transform: 'rotate(-2.13605deg)' }}
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-book-open w-5 h-5 md:w-8 md:h-8 text-white stroke-[3px]">
          <path d="M12 7v14"></path>
          <path d="M3 18a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h5a4 4 0 0 1 4 4 4 4 0 0 1 4-4h5a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1h-6a3 3 0 0 0-3 3 3 3 0 0 0-3-3z"></path>
        </svg>
      </div>
    </div>
  );
}
